<template>
  <v-app
    id="inspire"
    :dark="isDark"
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <ReloadNotification></ReloadNotification>
    <v-app-bar
      clipped-left
      flat
      fixed
      app
      :class="{ 'elevation-1': scrollPos > 0 }"
    >
      <v-btn icon @click.stop="drawer = !drawer" style="pointer-events: auto">
        <v-icon>fa-bars</v-icon>
      </v-btn>
      <div>
        <span class="brand">g</span>
        <span
          class="brand-italic"
          :style="{ color: getSocketStatus === false ? '#FFB300' : '' }"
          >k</span
        >
      </div>
      <span class="store-name ml-1 hidden-xs-only">
        {{ getOrganisationName }}
        <v-icon x-small>fa-caret-right</v-icon>
        {{ getStoreName }}
      </span>
      <v-spacer></v-spacer>
      <InventoryTransactionNotification></InventoryTransactionNotification>
      <HelperMenu></HelperMenu>
      <UserAdminLogin></UserAdminLogin>
      <v-btn @click="logout" icon style="pointer-events: auto">
        <v-icon>fa-sign-out-alt</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      floating
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      :class="{ transparent: $vuetify.breakpoint.lgAndUp }"
      width="300"
    >
      <NavigationDrawerList></NavigationDrawerList>
    </v-navigation-drawer>
    <v-content class="mt-3">
      <RequestAlert></RequestAlert>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>
    <v-dialog persistent v-model="relogWarning" width="500">
      <v-card>
        <v-card-title class="headline lighten-2" primary-title color="secondary"
          >Session expirée</v-card-title
        >

        <v-card-text>
          Votre session est expirée. Veuillez-vous reconnecter à nouveau.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sessionExpire">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-alert
      v-if="getSocketStatus === false"
      type="error"
      icon="fa-wifi"
      dense
      border="right"
      class="offline-alert"
    >
      Mode hors-ligne
    </v-alert> -->
    <ProgressOverlay></ProgressOverlay>
  </v-app>
</template>

<script>
import { router } from "@/router";
import * as socket from "@/socket";
import { mapGetters } from "vuex";
import {
  ProgressOverlay,
  RequestAlert,
  ReloadNotification
} from "@/modules/Shared";
import { HelperMenu } from "@/modules/Helper/components";
import { NavigationDrawerList } from "@/modules/Nav/components";
import { UserAdminLogin } from "@/modules/UserSettings/components";
import { InventoryTransactionNotification } from "@/modules/InventoryTransactionNotification/components";
export default {
  name: "AppLayout",
  components: {
    ProgressOverlay,
    RequestAlert,
    UserAdminLogin,
    InventoryTransactionNotification,
    ReloadNotification,
    NavigationDrawerList,
    HelperMenu
  },
  props: {
    source: String
  },
  data: () => ({
    scrollPos: 0,
    drawer: false,
    drawerRight: false,
    adminDialog: false,
    adminPassword: "",
    transitionName: "slide-left"
  }),
  created() {
    socket.connect();
    this.getData();
    window.addEventListener("scroll", () => {
      this.scrollPos = window.scrollY;
    });
  },
  computed: {
    ...mapGetters([
      "getOrganisationName",
      "getStoreName",
      "getIsAdmin",
      "isDark",
      "getUserLevel",
      "getSocketStatus"
    ]),
    userSettings() {
      return this.$store.getters.getUserSettings;
    },
    relogWarning() {
      return this.$store.getters.getTimerWarning;
    },
    toolBarColor() {
      return this.$store.getters.isDark === true ? "#303030" : "#fafafa";
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    }
  },
  methods: {
    async getData() {
      this.$store.dispatch("loadCustomUnits");
    },
    sessionExpire() {
      router.push("/");
    },
    logout() {
      this.$store.dispatch("logout");
    },
    setDarkTheme(v) {
      this.$vuetify.theme.dark = v;
    }
  },
  watch: {
    isDark: {
      immediate: true,
      handler: "setDarkTheme"
    }
  }
};
</script>

<style lang="scss" scoped>
.org-title {
  font-family: "Exo", sans-serif;
  font-size: 2.5em;
  height: 100%;
  padding-top: 0.2em;
  padding-left: 0.1em;
  padding-right: 0.1em;
  color: #424242;
}
.user-info {
  font-size: 1em;
  color: #424242;
}
.brand {
  font-size: 1.3rem;
  font-weight: 800;
}
.brand-italic {
  font-size: 1.3rem;
  font-weight: 900;
  font-family: "Merriweather", serif;
  font-style: italic;
  letter-spacing: -1px;
}
.store-name {
  opacity: 0.9;
  font-size: 0.75rem !important;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 1rem;
  text-transform: uppercase;
  font-family: "Roboto", sans-serif !important;
}
.navbar-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.fa-vgroup {
  font-size: 1.6rem;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.offline-alert {
  position: fixed;
  bottom: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 999;
}
</style>
